module.exports = __webpack_public_path__ + "img/search-ads-360.047ce102.png";